var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 199,
    height: 63,
    viewBox: "0 0 199 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24975",
    "data-name": "Group 24975",
    transform: "translate(-96 -125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2936",
    "data-name": "Rectangle 2936",
    width: 199,
    height: 63,
    rx: 10,
    transform: "translate(96 125)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "GET_IT_ON",
    "data-name": "GET IT ON",
    transform: "translate(148 148)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GET IT ON")), /*#__PURE__*/React.createElement("text", {
    id: "Google_Play",
    "data-name": "Google Play",
    transform: "translate(148 174)",
    fill: "#fff",
    fontSize: 26,
    fontFamily: "SFProDisplay-Semibold, SF Pro Display",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Google Play")), /*#__PURE__*/React.createElement("g", {
    id: "Group_24976",
    "data-name": "Group 24976",
    transform: "translate(-11718.4 -5298.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34_2.Google_PLay",
    transform: "translate(11827 5438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164568",
    "data-name": "Path 164568",
    d: "M66.3,39.539l-5.82-3.362-5.958,5.958,5.958,5.958,5.84-3.373a3.025,3.025,0,0,0-.02-5.182Z",
    transform: "translate(-37.384 -24.931)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164569",
    "data-name": "Path 164569",
    d: "M31.767,28.342,15.537,12a3.063,3.063,0,0,0-.907,2.177V42.462a3.065,3.065,0,0,0,.907,2.178Z",
    transform: "translate(-14.63 -11.138)",
    fill: "#3bd5f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164570",
    "data-name": "Path 164570",
    d: "M32.972,27.2l5.958-5.958.009-.009-7.984-4.6L20.432,10.454a2.986,2.986,0,0,0-3.065-.061,4.548,4.548,0,0,0-.625.464Z",
    transform: "translate(-15.835 -10)",
    fill: "#00f076"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164571",
    "data-name": "Path 164571",
    d: "M16.742,66.344a4.549,4.549,0,0,0,.625.464,3.13,3.13,0,0,0,1.492.4,3.072,3.072,0,0,0,1.553-.443l10.544-6.156,7.984-4.6-.009-.009-5.958-5.958Z",
    transform: "translate(-15.835 -32.843)",
    fill: "#f63448"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.c2517c69c84c9e343f6b89ddcb7e7af9.svg";
export { ForwardRef as ReactComponent };